<script lang="ts">
import Company from '@/domain/model/business/Company';
import PromisePeriodCell from '@/presentation/pages/resources/cells/PromisePeriodCell.vue';

export default {
  name: 'CurrentPromiseStatusColumn',
  components: { PromisePeriodCell },
  props: {
    company: { type: Company },
  },
};
</script>

<template>
  <Column field="plant.current_promise_status" style="width: 11rem">
    <template #header>
      {{ $t('glossary.current_period') }}

      <help-icon
        :title="$t('glossary.current_period')"
        :description="
          $t('features.long_term.columns.current_promise_tooltip')
        "
        link="https://support.sundata.nl/nl/articles/6161385-overzichtspagina-prestatiebewaking-op-lange-termijn"
        class="ml-1"
      />
    </template>
    <template #body="slotProps">
      <promise-period-cell
        :company="company"
        :promise-periods="slotProps.data.plant.promise_statuses"
        periods-to-show="current"
      />
    </template>
  </Column>
</template>

<style scoped></style>
